import React, { useEffect } from "react";
import DroneLonesHero from "../components/droneLonePage/DroneLonesHero";
 
import Navbar from "../components/homepage/Navbar";
import { Header, Footer } from "../shared";

const DroneLonesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <DroneLonesHero />
      <Footer />
    </div>
  );
};

export default DroneLonesPage;
